@if (landingDataComputed()) {
  <div class="tw:bg-white px-12 py-20 md:px-20 tw:xl:px-80">
    <div class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-8 tw:h-screen tw:m-auto">
      <div class="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:w-full">
        <img class="tw:w-32 tw:h-32" src="assets/icons/icon-orz-inactive.svg" alt="Organization Inactive" />
      </div>
      <div class="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:w-full">
        <h1 class="tw:text-2xl tw:font-bold tw:text-surface-900 tw:text-center tw:leading-tight">
          {{ landingDataComputed()?.title | transloco }}
        </h1>
        <p class="tw:text-lg tw:text-surface-500 tw:text-center tw:leading-normal">{{ landingDataComputed()?.subTitle | transloco }}</p>
      </div>

      <div class="tw:flex tw:flex-col tw:items-center tw:gap-4 tw:w-full">
        <p-button
          [label]="'organization_inactive.back_to_home' | transloco"
          (onClick)="signOut()"
          styleClass="allow-when-locked"
        ></p-button>
      </div>
    </div>
  </div>
}
